import { useState, useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import LazyLottie from "../components/LazyLottie";
import MatchdayChampionPromo from '../components/MatchdayChampionPromo';
import PatchworkPlanetPromo from '../components/PatchworkPlanetPromo';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

const PASSWORD_PROTECTION_ENABLED = false;

function Home() {
  const [showPasswordField, setShowPasswordField] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const [cookieConsent, setCookieConsent] = useState(null);

useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    // Only auto-route for REAL signed-in users (not anonymous guests)
    if (user && !user.isAnonymous) {
      navigate("/Games", { replace: true });
    }
  });

  return () => unsubscribe();
}, [navigate]);

useEffect(() => {
  const saved = localStorage.getItem('sportsbuff_cookie_consent');
  setCookieConsent(saved);
}, []);

const handleCookieChoice = (choice) => {
  localStorage.setItem('sportsbuff_cookie_consent', choice);
  setCookieConsent(choice);
};

const handleEnterClick = () => {
  if (PASSWORD_PROTECTION_ENABLED) {
    setShowPasswordField(true);
  } else {
    // bypass password protection
    localStorage.setItem('sportsAccess', 'true');
    navigate("/Games/choose-sport");
  }
};

  const handlePasswordSubmit = () => {
    if (password === 'ilovesports') {
      localStorage.setItem('sportsAccess', 'true');
      navigate('/sports');
    } else {
      setError('Incorrect password. Please try again.');
    }
  };

  return (
    <>
    <PatchworkPlanetPromo />
    <MatchdayChampionPromo />
    <div className="home-container" style={{ paddingBottom: '160px' }}>
            <p className="buff-definition">
        <strong>buff</strong> [noun] - a person who is enthusiastically interested in and very knowledgeable about a particular subject
      </p>
<LazyLottie
  srcUrl="/animations/orbitpulse.json"
  className="home-lottie"
  style={{ width: 300, height: 260 }}
  fallback={<div style={{ width: 300, height: 260 }} />}
/>

{!cookieConsent && (
  <div className="cookie-banner">
    <p className="cookie-banner-text">
      We use cookies to personalise ads and improve your experience. Please choose ACCEPT and help keep sportsbuff free.
    </p>

    <button className="cta-button" onClick={() => handleCookieChoice('accepted')}>
      ACCEPT
    </button>

    <button className="text-button" onClick={() => handleCookieChoice('rejected')}>
      REJECT
    </button>
  </div>
)}

      {/* Sticky footer with buttons or input */}
      <div className="home-footer">
{!showPasswordField ? (
  <>
    <button
      className="cta-button"
      onClick={handleEnterClick}
      disabled={!cookieConsent}
      style={!cookieConsent ? { opacity: 0.4, pointerEvents: 'none' } : undefined}
    >
      GET STARTED
    </button>

<button
  className="text-button"
  onClick={() => navigate("/signin")}
  disabled={!cookieConsent}
  style={!cookieConsent ? { opacity: 0.4, pointerEvents: "none" } : undefined}
>
  I ALREADY HAVE AN ACCOUNT
</button>
  </>
) : (
          <>
            <input
              type="password"
              className="shared-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: '300px', marginBottom: '8px' }}
            />
            <button className="cta-button" onClick={handlePasswordSubmit}>
              SUBMIT
            </button>
            {error && <p className="error-message">{error}</p>}
          </>
        )}
      </div>
    </div>
    </>
  );
}

export default Home;
